import React from "react";
import BrandLogo from "../BrandLogo/BrandLogo";
import "./style.css";

export default function PicturesShell({
  children,
  variant = "dark",
  badge = "Vehicle photos",
  showFooter = true,
  className = "",
  mainClassName = "",
}) {
  const isCamera = className.includes("pi-pictures-page--camera");

  return (
    <div className={`pi-pictures-page ${className}`.trim()}>
      <div className="pi-pictures-page__fx" aria-hidden="true">
        <span className="pi-pictures-page__orb pi-pictures-page__orb--a" />
        <span className="pi-pictures-page__orb pi-pictures-page__orb--b" />
        <span className="pi-pictures-page__orb pi-pictures-page__orb--gold" />
        <span className="pi-pictures-page__aurora pi-pictures-page__aurora--a" />
        <span className="pi-pictures-page__aurora pi-pictures-page__aurora--b" />
        <span className="pi-pictures-page__grid" />
        <span className="pi-pictures-page__beam" />
        <span className="pi-pictures-page__mesh" />
        <span className="pi-pictures-page__grain" />
        {!isCamera ? <span className="pi-pictures-page__glow" /> : null}
      </div>

      <div className="pi-pictures-page__content">
        <header className="pi-pictures-header">
          <BrandLogo variant={variant} compact className="pi-pictures-header__logo" />
          {badge ? <span className="pi-pictures-header__badge">{badge}</span> : null}
        </header>
        <main className={`pi-pictures-main ${mainClassName}`.trim()}>{children}</main>
        {showFooter ? (
          <footer className="pi-pictures-footer">
            <p>© {new Date().getFullYear()} AutoTrade Port</p>
          </footer>
        ) : null}
      </div>
    </div>
  );
}
